var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!['/aqt','/External'].includes(_vm.$route.path))?_c('div',{staticClass:"goback"},[_c('i',{staticClass:"iconfont iconai207",on:{"click":_vm.goBack}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }